import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const METER_TYPES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('METER_TYPES');
export const METER_TYPES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	METER_TYPES_CRUD_ACTION_CONSTANTS
);
